<template>
  <div class="card sale-header-card border-0 shadow-sm rounded-4 mb-3">
    <div class="card-body p-3 bg-white">
      <!-- 1-qator: Mijoz, Avtomobil, Usta -->
      <div class="row g-2 mb-2">
        <div class="col-12 col-md-4">
          <label class="small text-muted mb-1 d-block">Mijoz</label>
          <div class="d-flex align-items-center gap-1">
            <v-select
              class="client-select flex-grow-1"
              :value="form.kontragent_id"
              :options="clientList"
              :reduce="c => c.id"
              label="name"
              :filter="filterClients"
              placeholder="Mijoz tanlang yoki qidiring..."
              @input="onClientChange"
            >
              <template #no-options>Topilmadi</template>
              <template #option="c">
                <div>{{ c.name }}</div>
                <small v-if="c.phone_number" class="text-muted">{{ c.phone_number }}</small>
              </template>
            </v-select>
            <button type="button" class="btn-plus" @click="openClientModal" title="Yangi mijoz">+</button>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <label class="small text-muted mb-1 d-block">Avtomobil</label>
          <div class="d-flex align-items-center gap-1">
            <select
              :value="selectedCarId"
              class="form-control-modern flex-grow-1"
              @change="onCarChange"
              :disabled="clientCars.length === 0"
            >
              <option :value="null">{{ clientCars.length === 0 ? 'Avto yo\'q' : 'Tanlang...' }}</option>
              <option v-for="car in clientCars" :key="car.id" :value="car.id">
                {{ carLabel(car) }}
              </option>
            </select>
            <button
              type="button"
              class="btn-plus"
              @click="openCarModal"
              :disabled="!form.kontragent_id"
              title="Yangi avtomobil"
            >+</button>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <label class="small text-muted mb-1 d-block">Usta</label>
          <select :value="form.master_user_id" class="form-control-modern" @change="onMasterChange">
            <option :value="null">Tanlanmagan</option>
            <option v-for="u in ustaList" :key="u.id" :value="u.id">
              {{ u.name }} ({{ u.bonus || u.percent || 0 }}%)
            </option>
          </select>
        </div>
      </div>

      <!-- 2-qator: Bron, Narx turi, Izoh -->
      <div class="row g-2">
        <div class="col-12 col-md-4">
          <label class="small text-muted mb-1 d-block">Bron/Zakas</label>
          <select :value="form.bron_id" class="form-control-modern" @change="onBronChange">
            <option :value="null">Yo'q</option>
            <option v-for="b in bronList" :key="b.id" :value="b.id">
              #{{ b.id }} - {{ b.kontragent ? b.kontragent.name : 'Nomsiz' }}
            </option>
          </select>
        </div>
        <div class="col-6 col-md-4">
          <label class="small text-muted mb-1 d-block">Narx turi</label>
          <select :value="saleType" class="form-control-modern" @change="onSaleTypeChange">
            <option value="chakana">Chakana</option>
            <option value="optom">Optom</option>
          </select>
        </div>
        <div class="col-6 col-md-4">
          <label class="small text-muted mb-1 d-block">Izoh</label>
          <input
            type="text"
            :value="form.comment"
            @input="emit('comment', $event.target.value)"
            class="form-control-modern"
            placeholder="Izoh..."
          >
        </div>
      </div>
    </div>

    <!-- Yangi mijoz modali -->
    <b-modal ref="clientModal" title="Yangi mijoz qo'shish" hide-footer centered>
      <div class="mb-3">
        <label class="form-label">F.I.O <span class="text-danger">*</span></label>
        <input v-model="newClient.name" type="text" class="form-control" placeholder="Familiya Ism Otasining ismi" maxlength="50">
      </div>
      <div class="mb-3">
        <label class="form-label">Telefon <span class="text-danger">*</span></label>
        <input v-model="newClient.phone_number" type="text" class="form-control" placeholder="+998901234567" maxlength="15">
      </div>
      <div class="mb-3">
        <label class="form-label">Mijoz turi <span class="text-danger">*</span></label>
        <div class="ct-toggle">
          <button type="button" :class="['ct-btn', { active: Number(newClient.type) === 1 }]" @click="newClient.type = 1">
            <b-icon icon="person-fill" class="mr-1"></b-icon> Oddiy mijoz
          </button>
          <button type="button" :class="['ct-btn', { active: Number(newClient.type) === 2 }]" @click="newClient.type = 2">
            <b-icon icon="tools" class="mr-1"></b-icon> Usta mijoz
          </button>
          <button type="button" :class="['ct-btn', { active: Number(newClient.type) === 3 }]" @click="newClient.type = 3">
            <b-icon icon="gear-fill" class="mr-1"></b-icon> Zapchas mijoz
          </button>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label">Sotuv turi</label>
        <div class="st-toggle">
          <button type="button" :class="['st-btn', { active: newClient.sale_type === 'chakana' }]" @click="newClient.sale_type = 'chakana'">
            Chakana
          </button>
          <button type="button" :class="['st-btn', { active: newClient.sale_type === 'optom' }]" @click="newClient.sale_type = 'optom'">
            Optom
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary btn-sm" @click="$refs.clientModal.hide()">Bekor</button>
        <button type="button" class="btn btn-primary btn-sm" @click="saveClient" :disabled="savingClient">
          {{ savingClient ? 'Saqlanmoqda...' : 'Saqlash' }}
        </button>
      </div>
    </b-modal>

    <!-- Yangi avtomobil modali -->
    <b-modal ref="carModal" title="Yangi avtomobil qo'shish" hide-footer centered>
      <div class="mb-3">
        <label class="form-label">Brand <span class="text-danger">*</span></label>
        <select v-model="newCar.brand_id" class="form-control" @change="onBrandSelect">
          <option :value="null">Tanlang...</option>
          <option v-for="b in brands" :key="b.id" :value="b.id">{{ b.name }}</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label">Model</label>
        <select v-model="newCar.model_id" class="form-control" :disabled="!newCar.brand_id">
          <option :value="null">Tanlang...</option>
          <option v-for="m in models" :key="m.id" :value="m.id">{{ m.name }}</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label">Davlat raqami <small class="text-muted">(ixtiyoriy)</small></label>

        <!-- Jismoniy / Yuridik shaxs -->
        <div class="plate-type-toggle">
          <button type="button" :class="['pt-btn', { active: plateType === 'jismoniy' }]" @click="plateType = 'jismoniy'">Jismoniy</button>
          <button type="button" :class="['pt-btn', { active: plateType === 'yuridik' }]" @click="plateType = 'yuridik'">Yuridik</button>
        </div>

        <!-- O'zbekiston raqami: 01 [A] 123 AA/AAA -->
        <div class="plate-inputs">
          <input v-model="plate.region" @input="sanitizeDigits('region', 2)" type="text" inputmode="numeric"
            class="form-control plate-cell plate-region" maxlength="2" placeholder="01">
          <input v-if="plateType === 'jismoniy'" v-model="plate.letter" @input="sanitizeLetters('letter', 1)" type="text"
            class="form-control plate-cell plate-letter" maxlength="1" placeholder="A">
          <input v-model="plate.digits" @input="sanitizeDigits('digits', 3)" type="text" inputmode="numeric"
            class="form-control plate-cell plate-digits" maxlength="3" placeholder="123">
          <input v-model="plate.letters" @input="sanitizeLetters('letters', plateType === 'yuridik' ? 3 : 2)" type="text"
            class="form-control plate-cell plate-letters" :maxlength="plateType === 'yuridik' ? 3 : 2"
            :placeholder="plateType === 'yuridik' ? 'ABC' : 'AB'">
        </div>
        <div v-if="assembledPlate" class="plate-preview">{{ assembledPlate }}</div>
      </div>
      <div class="row g-2 mb-3">
        <div class="col-6">
          <label class="form-label">Rang</label>
          <input v-model="newCar.color" type="text" class="form-control" placeholder="Oq, Qora..." maxlength="50">
        </div>
        <div class="col-6">
          <label class="form-label">Yil</label>
          <input v-model.number="newCar.year" type="number" class="form-control" placeholder="2024" min="1900" max="2030">
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary btn-sm" @click="$refs.carModal.hide()">Bekor</button>
        <button type="button" class="btn btn-primary btn-sm" @click="saveCar" :disabled="savingCar">
          {{ savingCar ? 'Saqlanmoqda...' : 'Saqlash' }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SaleHeaderBar',
  props: {
    form:       { type: Object, required: true },
    clientList: { type: Array,  default: () => [] },
    ustaList:   { type: Array,  default: () => [] },
    bronList:   { type: Array,  default: () => [] },
    clientCars: { type: Array,  default: () => [] },
    saleType:   { type: String, default: 'chakana' },
  },
  data() {
    return {
      selectedCarId: null,
      // Yangi mijoz — default: Oddiy mijoz (type=1), Chakana sotuv
      newClient: { name: '', phone_number: '+998', type: 1, sale_type: 'chakana' },
      savingClient: false,
      // Yangi avto
      newCar: { brand_id: null, model_id: null, car_number: '', color: '', year: null },
      savingCar: false,
      brands: [],
      models: [],
      // Davlat raqami (O'zbekiston formati) — bo'laklarga ajratilgan
      plateType: 'jismoniy', // 'jismoniy' (01 A 123 AB) | 'yuridik' (01 123 ABC)
      plate: { region: '', letter: '', digits: '', letters: '' },
    };
  },
  computed: {
    // Bo'laklardan to'liq raqamni yig'ish (bo'sh bo'laklar tashlab ketiladi)
    assembledPlate() {
      const r = (this.plate.region || '').trim();
      const l = (this.plate.letter || '').trim();
      const d = (this.plate.digits || '').trim();
      const ls = (this.plate.letters || '').trim();
      const parts = this.plateType === 'yuridik' ? [r, d, ls] : [r, l, d, ls];
      return parts.filter(Boolean).join(' ').trim();
    },
  },
  emits: ['update:form', 'client-changed', 'master-changed', 'bron-selected', 'car-selected', 'client-added', 'car-added', 'sale-type-changed'],
  methods: {
    emit(key, value) {
      this.$emit('update:form', { ...this.form, [key]: value });
    },
    carLabel(car) {
      const parts = [];
      if (car.brand?.name) parts.push(car.brand.name);
      if (car.model?.name) parts.push(car.model.name);
      if (car.car_number) parts.push(car.car_number);
      return parts.join(' ') || `Avto #${car.id}`;
    },
    onClientChange(val) {
      this.selectedCarId = null;
      this.$emit('update:form', { ...this.form, kontragent_id: val || null, car_number: '' });
      this.$emit('client-changed', val || null);
    },
    // Mijozni ism va telefon raqami bo'yicha (matnning istalgan joyida) qidirish —
    // native <select> faqat bosh harf bo'yicha qidirar edi.
    filterClients(options, search) {
      const q = (search || '').toLowerCase().trim();
      if (!q) return options;
      return options.filter(c =>
        (c.name || '').toLowerCase().includes(q) ||
        (c.phone_number || '').toLowerCase().includes(q)
      );
    },
    onCarChange(e) {
      const val = e.target.value ? Number(e.target.value) : null;
      this.selectedCarId = val;
      const car = val ? this.clientCars.find(c => c.id === val) : null;
      if (car) {
        this.$emit('update:form', { ...this.form, car_number: car.car_number || '' });
      } else {
        this.$emit('update:form', { ...this.form, car_number: '' });
      }
      this.$emit('car-selected', car);
    },
    onMasterChange(e) {
      const val = e.target.value ? Number(e.target.value) : null;
      this.$emit('update:form', { ...this.form, master_user_id: val });
      this.$emit('master-changed', val);
    },
    onBronChange(e) {
      const val = e.target.value ? Number(e.target.value) : null;
      this.$emit('update:form', { ...this.form, bron_id: val });
      this.$emit('bron-selected', val);
    },

    onSaleTypeChange(e) {
      this.$emit('sale-type-changed', e.target.value);
    },

    // === Yangi mijoz ===
    openClientModal() {
      // Default: Oddiy mijoz (type=1), Chakana sotuv
      this.newClient = { name: '', phone_number: '+998', type: 1, sale_type: 'chakana' };
      this.$refs.clientModal.show();
    },
    async saveClient() {
      if (!this.newClient.name || this.newClient.name.trim().length < 3) {
        return alert("F.I.O kamida 3 ta belgi bo'lishi kerak!");
      }
      if (!this.newClient.phone_number || this.newClient.phone_number.trim().length < 5) {
        return alert("Telefon raqamini kiriting!");
      }
      this.savingClient = true;
      try {
        const sklad_id = Number(localStorage.getItem('sklad_id')) || 1;
        const res = await axios.post('api/v1/kontragent/', {
          name: this.newClient.name.trim(),
          phone_number: this.newClient.phone_number.trim(),
          type: Number(this.newClient.type) || 1,
          sklad_id,
          sale_type: this.newClient.sale_type || 'chakana',
          comment: ' ',
        });
        const created = res.data?.data || res.data;
        this.$refs.clientModal.hide();
        this.$emit('client-added', created);
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "Mijozni saqlashda xato"));
      } finally {
        this.savingClient = false;
      }
    },

    // === Yangi avtomobil ===
    openCarModal() {
      this.newCar = { brand_id: null, model_id: null, car_number: '', color: '', year: null };
      this.plateType = 'jismoniy';
      this.plate = { region: '', letter: '', digits: '', letters: '' };
      this.models = [];
      if (this.brands.length === 0) this.fetchBrands();
      this.$refs.carModal.show();
    },
    // Faqat raqam qoldirish (bo'lak uzunligini cheklab)
    sanitizeDigits(key, max) {
      this.plate[key] = (this.plate[key] || '').replace(/\D/g, '').slice(0, max);
    },
    // Faqat harf qoldirish (katta harfga o'tkazib)
    sanitizeLetters(key, max) {
      this.plate[key] = (this.plate[key] || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, max);
    },
    async fetchBrands() {
      try {
        const res = await axios.get('api/v1/brand/');
        this.brands = res.data?.data || res.data || [];
      } catch (e) { this.brands = []; }
    },
    async onBrandSelect() {
      this.newCar.model_id = null;
      this.models = [];
      if (!this.newCar.brand_id) return;
      try {
        const res = await axios.get('api/v1/model/', { params: { brand_id: this.newCar.brand_id } });
        this.models = res.data?.data || res.data || [];
      } catch (e) { this.models = []; }
    },
    async saveCar() {
      if (!this.newCar.brand_id) {
        return alert("Brandni tanlang!");
      }
      // Davlat raqami ixtiyoriy — yig'ilgan raqamni ishlatamiz (bo'sh bo'lsa ham bo'ladi)
      this.savingCar = true;
      try {
        const payload = {
          kontragent_id: this.form.kontragent_id,
          brand_id: this.newCar.brand_id,
          model_id: this.newCar.model_id,
          car_number: this.assembledPlate,
          color: this.newCar.color?.trim() || '',
          year: this.newCar.year || null,
        };
        const res = await axios.post('api/v1/client-profile/cars', payload);
        const created = res.data?.data || res.data;
        this.$refs.carModal.hide();
        this.$emit('car-added', created);
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "Avtomobilni saqlashda xato"));
      } finally {
        this.savingCar = false;
      }
    },
  },
  watch: {
    clientCars(cars) {
      // Kechiktirilgan savdo tiklanganda saqlangan mashinani dropdownda ko'rsatish
      if (this.form.car_number) {
        const match = (cars || []).find(c => c.car_number === this.form.car_number);
        this.selectedCarId = match ? match.id : null;
      } else {
        this.selectedCarId = null;
      }
    },
  },
}
</script>

<style scoped>
.sale-header-card {
  position: relative;
  z-index: 50;
  overflow: visible;
}
.client-select {
  position: relative;
  z-index: 60;
}
.client-select ::v-deep .vs__dropdown-menu {
  z-index: 1060;
}

/* Mijoz turi (Oddiy/Usta/Zapchas) toggle */
.ct-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 6px;
}
.ct-btn {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  font-weight: 700;
  font-size: 12px;
  padding: 9px 6px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.15s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ct-btn:hover:not(.active) { border-color: #c7d2fe; }
.ct-btn.active {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 3px 10px rgba(161, 66, 244, 0.3);
}

/* Sotuv turi (Chakana/Optom) toggle */
.st-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}
.st-btn {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  font-weight: 700;
  font-size: 13px;
  padding: 10px 6px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.15s;
}
.st-btn:hover:not(.active) { border-color: #c7d2fe; }
.st-btn.active {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 3px 10px rgba(161, 66, 244, 0.3);
}

/* Davlat raqami — Jismoniy/Yuridik toggle */
.plate-type-toggle {
  display: inline-flex;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 3px;
  margin-bottom: 8px;
}
.pt-btn {
  border: none;
  background: transparent;
  color: #64748b;
  font-weight: 700;
  font-size: 12px;
  padding: 5px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.15s;
}
.pt-btn.active {
  background: #3b82f6;
  color: #fff;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.3);
}

/* Raqam bo'laklari: 01 [A] 123 AA */
.plate-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}
.plate-cell {
  text-align: center;
  text-transform: uppercase;
  font-weight: 800;
  letter-spacing: 1px;
  font-size: 16px;
  padding: 8px 4px;
}
.plate-region { width: 56px; }
.plate-letter { width: 44px; }
.plate-digits { width: 72px; }
.plate-letters { width: 64px; }
.plate-preview {
  margin-top: 6px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #0f172a;
  font-size: 14px;
}

.form-control-modern {
  border: 1px solid #e0e6ed;
  border-radius: 10px;
  padding: 8px 12px;
  width: 100%;
  font-size: 0.85rem;
  transition: all 0.3s;
  background: white;
}
.form-control-modern:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  outline: none;
}
.form-control-modern:disabled {
  background: #f5f5f5;
  color: #999;
}
.client-select ::v-deep .vs__dropdown-toggle {
  border: 1px solid #e0e6ed;
  border-radius: 10px;
  padding: 2px 4px;
  min-height: 37px;
  background: white;
}
.client-select ::v-deep .vs__search,
.client-select ::v-deep .vs__selected {
  font-size: 0.85rem;
}
.btn-plus {
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 10px;
  border: 1px solid #3b82f6;
  background: #3b82f6;
  color: white;
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.btn-plus:hover {
  background: #2563eb;
  border-color: #2563eb;
}
.btn-plus:disabled {
  background: #cbd5e1;
  border-color: #cbd5e1;
  cursor: not-allowed;
}
</style>
